var exports = {
  "kL": "xcc377c0b--964683--container",
  "Sl": "xcc377c0b--964683--image",
  "h_": "xcc377c0b--964683--description",
};

module.exports = exports;
